package data.network.result

import kotlinx.serialization.Serializable
import models.PersonPreview
import models.VideoDetails

@Serializable
data class SearchResponse(
    val page: Int? = null,
    val result: List<VideoDetails>? = null,
    val persons: List<PersonPreview>? = null,
    val totalPages: Int? = null,
    val totalResults: Int? = null,
)
